import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'This literally saved me 10 hours this week alone. I finally understand how to get ChatGPT to write content that actually sounds like me.',
  name: 'Sarah Jenkins',
  role: 'Real Estate Agent',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: 'The sales prompts are incredible. I used one template for a cold email campaign and booked three meetings the next day. Worth 100x the price.',
  name: 'Marcus Chen',
  role: 'B2B Consultant',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: 'I was so overwhelmed with content creation. Now I just open the Notion board, pick a prompt, and my Instagram posts are done for the week.',
  name: 'Elena Rodriguez',
  role: 'Fitness Coach',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: 'The organization of this library is what makes it premium. No fluff, just highly practical prompts that work immediately. A must-have.',
  name: 'David Thompson',
  role: 'Agency Owner',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: 'I thought I knew how to use AI until I read these prompts. The level of detail and context provided completely changed my output quality.',
  name: 'Rachel Kim',
  role: 'Freelance Copywriter',
  image: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: "Finally, a product that isn't a 10-hour course. I bought it, copied a prompt a few minutes later, and was able to solve a client issue. Brilliant.",
  name: 'James Wilson',
  role: 'Startup Founder',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=200&h=200'
}];
export function SocialProof() {
  return <section id="reviews" className="py-32 relative" data-id="element-284">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-285">
        <div className="text-center mb-20" data-id="element-286">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold text-sm font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-287">
            Trusted by Professionals
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite tracking-tight leading-[1.05]" data-id="element-288">
            Built for{' '}
            <span className="text-gold" data-id="element-289">ambitious professionals.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-290">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-black-charcoal border border-white/5 p-8 rounded-xl flex flex-col" data-id="element-291">
              <div className="flex gap-1 mb-6" data-id="element-292">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 text-gold fill-gold" data-id="element-293" />)}
              </div>
              <p className="text-base text-offwhite leading-relaxed mb-8 flex-grow font-medium" data-id="element-294">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-295">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border border-white/10 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-296" />
                <div data-id="element-297">
                  <h4 className="text-sm font-medium text-offwhite" data-id="element-298">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-muted" data-id="element-299">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}